/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Assistant_Activity_Select_GroupInputs */



/**
* | output |
* | --- |
* | "Switched to {group}" |
*
* @param {Assistant_Activity_Select_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_select_group = /** @type {((inputs: Assistant_Activity_Select_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Select_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Passage à ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Umgeschaltet auf ${i?.group}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Passato a ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Переключено на ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se cambió a ${i?.group}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已切换至${i?.group}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group}に切り替えました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} पर स्विच किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Alterado para ${i?.group}`)
	return /** @type {LocalizedString} */ (`Switched to ${i?.group}`)
});